import React, { useState, useEffect } from "react";
import { Notification } from "@/types/Notification";
import { Error, Info, Warning , CloseIcon , Check} from "@/components/icons";

interface NotificationProps {
  notification: Notification;
  onClose: (id: number) => void;
}

const NotificationView: React.FC<NotificationProps> = ({
  notification,
  onClose,
}) => {
  const [visible, setVisible] = useState(true);
  const getBackgroundColorClass = (type: string) => {
    switch (type) {
      case "success":
        return "bg-green-600";
      case "error":
        return "bg-red-600";
      case "warning":
        return "bg-yellow-600";
      case "info":
        return "bg-blue-600";
      default:
        return "bg-gray-600";
    }
  };

  const getAccentColorClass = (type: string) => {
    switch (type) {
      case "success":
        return "text-green-600";
      case "error":
        return "text-red-600";
      case "warning":
        return "text-yellow-600";
      case "info":
        return "text-blue-600";
      default:
        return "text-gray-600";
    }
  };

  const getIcon = (type: string) => {
    switch (type) {
      case "success":
        return <Check />;
      case "error":
        return <Error />;
      case "warning":
        return <Warning />;
      case "info":
        return <Info />;
      default:
        return <Check />;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      onClose(notification.id);
    }, 3000);
    return () => clearTimeout(timer);
  }, [notification.id, onClose]);

  if(!visible) return null;
  return (
    <div
      className={`flex flex-col justify-center min-w-72 shadow-lg rounded-lg bg-white  overflow-hidden animate-slide-up pe-3 border border-slate-200`}
    >
      <div className={`flex space-x-2 justify-between items-center`}>
        <div className="flex space-x-2 items-center">
          <div
            className={`flex items-center justify-center ${getBackgroundColorClass(notification.type)} h-14 w-14`}
          >
            <div className="h-6 w-6">{getIcon(notification.type)}</div>
          </div>
          <div className="px-2">
            <p className={`text-sm ${getAccentColorClass(notification.type)}`}>
              {notification.title}
            </p>
            <p className="text-xs">{notification.subtitle}</p>
          </div>
        </div>
        <div
          className="h-4 w-4 cursor-pointer"
          onClick={() => {
            setVisible(false);
            onClose(notification.id);
          }}
          role="button"
          tabIndex={0}
          aria-label="Close notification"
        >
          <CloseIcon size="sm" color="gray-400" />
        </div>
      </div>
    </div>
  );
};

export default NotificationView;
